// Le champ ne porte que le libellé personnalisé : vide, la page participant affiche son libellé
// par défaut dans la langue du webinaire. Un texte saisi est gardé tel quel, même s'il ressemble
// à un libellé par défaut : la langue du back-office ne doit jamais décider de ce qui est enregistré.
export function toCtaButtonLabelInput(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
}
